module.exports = __webpack_public_path__ + "static/media/lds-logo_sq.aa22df92.svg";